import {
  SET_BRAND_ID_LIST,
  SET_ATB_CODES_DATA,
  CLEAR_ATB_CODES_DATA,
  SET_APPLY_CODES_STEP,
} from '@app/actions/_types';

import { APPLY_CODES_FLOW_SELECTION } from '@app/constants';

const initialApplyCodesState = {
  brandIdList: undefined,
  ATBCodesData: null,
  applyCodesStep: APPLY_CODES_FLOW_SELECTION,
};

export default (state = initialApplyCodesState, { type, payload }) => {
  switch (type) {
    case SET_BRAND_ID_LIST:
      return { ...state, brandIdList: payload };
    case SET_ATB_CODES_DATA:
      return { ...state, ATBCodesData: payload };
    case CLEAR_ATB_CODES_DATA:
      return { ...state, ATBCodesData: null };
    case SET_APPLY_CODES_STEP:
      return { ...state, applyCodesStep: payload };
    default:
      return state;
  }
};
